

interface RetailPartnersSectionProps {
  sectionTitle?: string
  mainHeading: string
  description: string
  imageSrc: string
  imageAlt: string
  backgroundColor?: string
  buttonText?: string
  onButtonClick?: () => void
}

const RetailPartnersSection = ({
  sectionTitle = "Retail Partners",
  mainHeading,
  description,
  imageSrc,
  imageAlt,
  backgroundColor = "#FFFFFF",
  buttonText = "Details",
  onButtonClick
}: RetailPartnersSectionProps) => {
  return (
    <section
      className="w-full px-4 py-12 md:px-16 md:py-20"
      style={{
        backgroundColor: backgroundColor
      }}
    >
      <div className="flex flex-col lg:flex-row lg:items-center lg:h-full max-w-7xl mx-auto">
        {/* Image - Top on mobile, Left on desktop */}
        <div className="flex items-center justify-center mb-8 lg:mb-0">
          <div className="relative w-80 h-80 md:w-96 md:h-96 lg:w-[488px] lg:h-[400px]">
            <img
              src={imageSrc}
              alt={imageAlt}
              fill
              className="object-cover lg:object-contain"
              priority
            />
          </div>
        </div>

        {/* Gap between image and content - only on desktop */}
        <div className="hidden lg:block lg:w-32"></div>

        {/* Content - Bottom on mobile, Right on desktop */}
        <div className="flex-1 text-center lg:text-left">
          {/* Section Title Label */}
          <h3
            className="text-lg md:text-xl lg:text-2xl mb-4"
            style={{
              fontFamily: 'Cardo, serif',
              color: '#764F2B',
              fontWeight: '400',
              fontStyle: 'italic'
            }}
          >
            {sectionTitle}
          </h3>

          {/* Main Heading */}
          <h2
            className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl mb-6"
            style={{
              fontFamily: 'Cardo, serif',
              color: '#000000',
              fontWeight: '400',
              lineHeight: '1.1'
            }}
          >
            {mainHeading}
          </h2>

          {/* Description */}
          <p
            className="text-sm md:text-base mb-8 lg:mb-10"
            style={{
              fontFamily: 'Plus Jakarta Sans, sans-serif',
              color: '#000000',
              fontWeight: '400',
              lineHeight: '1.6'
            }}
          >
            {description}
          </p>

          {/* Button */}
          <button
            className="px-6 py-3 md:px-8 md:py-4 text-sm md:text-base font-medium transition-all duration-300 hover:bg-gray-800"
            style={{
              backgroundColor: '#000000',
              color: '#FFFFFF',
              fontFamily: 'Plus Jakarta Sans, sans-serif',
              border: 'none',
              cursor: 'pointer'
            }}
            onClick={onButtonClick}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  )
}

export default RetailPartnersSection